import React, { startTransition, useEffect, useState } from 'react';
import { Button, Input } from 'antd';
import './index.scss';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store';
import { getAllVoucherList } from '../../../../store/vouchers/voucherSlice';

const VoucherManagement: React.FC = () => {
  const voucherSlice = useSelector((state: RootState) => state.voucher);
  const { data } = voucherSlice;
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredVouchers, setFilteredVouchers] = useState(data);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      dispatch(getAllVoucherList());
    } catch (error) {
      console.log(`${error}`);
    }
  }, [dispatch]);

  useEffect(() => {
    const filtered = data.filter((voucher) => voucher.name.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredVouchers(filtered);
  }, [searchTerm, data]);

  const addVoucher = () => {
    startTransition(() => {
      navigate(`/e-voucher/create`);
    });
  };

  return (
    <div className="voucher-management">
      <div className="header">
        <div>
          <h5>バウチャー情報</h5>
          <Input
            placeholder="バウチャーコードを入力してください"
            allowClear
            className="search-bar"
            size="large"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="actions">
          <Button className="create-button" type="primary" onClick={addVoucher}>
            新作成
          </Button>
        </div>
      </div>
      {/* <div className="voucher-list">
        {filteredVouchers.map((voucher) => (
          <Card
            loading={loading}
            key={voucher.id}
            className={`voucher-card ${voucher.status === '使用可能' ? 'active' : 'expired'}`}
            cover={
              <img
                alt="voucher"
                src={`${process.env.REACT_APP_API_URL}${voucher.img}`}
                style={{
                  width: '100%',
                  height: '300px',
                  objectFit: 'cover',
                  borderTopLeftRadius: '8px',
                  borderTopRightRadius: '8px',
                }}
              />
            }
            style={{ padding: '0px' }}
            onClick={() => navigate(`/e-voucher/${voucher.id}`)}
          >
            <h3>{voucher.name}</h3>
            <p>{voucher.content}</p>
            <div className="footer">
              <span className="expiry-date">期限: {voucher.expDate}</span>
              <span className={`status-tag ${voucher.status === '使用可能' ? 'active-tag' : 'expired-tag'}`}>
                {voucher.status === '使用可能' ? '使用可能' : '期限切れ'}
              </span>
            </div>
          </Card>
        ))}
      </div> */}
      <div className="voucher-list">
        {filteredVouchers.map((voucher) => (
          <div
            key={voucher.id}
            className={`voucher-card ${voucher.status === '使用可能' ? 'active' : 'expired'}`}
            style={{
              borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              width: '280px',
              minHeight: '360px',
              backgroundColor: '#fff',
              margin: '8px',
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={() => navigate(`/e-voucher/${voucher.id}`)}
          >
            <div style={{ position: 'relative' }}>
              <img
                alt="voucher"
                src={`${process.env.REACT_APP_API_URL}${voucher.img}`}
                style={{
                  width: '100%',
                  height: '250px',
                  objectFit: 'cover',
                }}
              />
              <div className="voucher-name">{voucher.name}</div>
            </div>

            <div className="voucher-content">{voucher.content}</div>

            <div className="footer">
              <span>期限：{voucher.expDate}</span>
              <span className={`status-tag ${voucher.status === '使用可能' ? 'active-tag' : 'expired-tag'}`}>
                {voucher.status === '使用可能' ? '使用可能' : '期限切れ'}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VoucherManagement;
